<ng-container *ngIf="result">
	<div class="sjr-row sjr-primary">
		<span class="sjr-customer-name">{{ result.customerName || 'Unknown' }}</span>
		<span *ngIf="result.code" class="sjr-code">{{ result.code }}</span>
		<span *ngIf="result.subTotal" class="sjr-subtotal">{{ result.subTotal / 100 | currency:(result.currency || 'USD') }}</span>
		<span *ngIf="result.state === 'closed' && result.closedReason" class="sjr-closed-reason">{{ result.closedReason }}</span>
	</div>
	<div class="sjr-row sjr-secondary">
		<ng-container *ngIf="result.timeline">{{ result.timeline * 1000 | date:'mediumDate' }}</ng-container>
	</div>
	<div class="sjr-row sjr-tertiary">
		<ng-container *ngIf="result.phone">{{ result.phone }}</ng-container>
		<ng-container *ngIf="result.phone && result.email">&middot;</ng-container>
		<ng-container *ngIf="result.email">{{ result.email }}</ng-container>
	</div>
	<div *ngIf="result.additionalContactNames?.length || result.additionalContactEmails?.length || result.additionalContactPhones?.length" class="sjr-row sjr-contacts">
		<span class="sjr-contacts-label">Additional contacts:</span>
		<span *ngFor="let name of result.additionalContactNames || []" class="sjr-contact-name">{{ name }}</span>
		<span *ngFor="let email of result.additionalContactEmails || []" class="sjr-contact-email">{{ email }}</span>
		<span *ngFor="let phone of result.additionalContactPhones || []" class="sjr-contact-phone">{{ phone }}</span>
	</div>
</ng-container>